import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-crown-icon',
  template: `
    <span class="crown-icon-wrapper" *ngIf="!showBadge" [ngClass]="customClass">
      <svg
        class="crown-icon"
        [attr.width]="size"
        [attr.height]="size"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient [id]="gradientId">
            <stop offset="0%" [style.stop-color]="color" />
            <stop offset="100%" [style.stop-color]="color" />
          </radialGradient>
        </defs>
        <path
          d="M4 16L2 6l5 3 2-5h6l2 5 5-3-2 10H4z"
          [attr.fill]="'url(#' + gradientId + ')'"
          [attr.stroke]="color"
          stroke-width="1"
        />
        <rect x="3" y="16" width="18" height="4" rx="1" [attr.fill]="'url(#' + gradientId + ')'" />
        <circle cx="12" cy="12" r="2" fill="#FFF" opacity="0.9" />
        <circle cx="7" cy="13" r="1.5" fill="#FFF" opacity="0.9" />
        <circle cx="17" cy="13" r="1.5" fill="#FFF" opacity="0.9" />
      </svg>
    </span>

    <span class="section-title-with-badge" *ngIf="showBadge">
      <span class="inline-pro-badge">
        <svg
          class="crown-icon"
          width="12"
          height="12"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient [id]="gradientId">
              <stop offset="0%" [style.stop-color]="color" />
              <stop offset="100%" [style.stop-color]="color" />
            </radialGradient>
          </defs>
          <path
            d="M4 16L2 6l5 3 2-5h6l2 5 5-3-2 10H4z"
            [attr.fill]="'url(#' + gradientId + ')'"
            [attr.stroke]="color"
            stroke-width="1"
          />
          <rect
            x="3"
            y="16"
            width="18"
            height="4"
            rx="1"
            [attr.fill]="'url(#' + gradientId + ')'"
          />
          <circle cx="12" cy="12" r="2" fill="#FFF" opacity="0.9" />
          <circle cx="7" cy="13" r="1.5" fill="#FFF" opacity="0.9" />
          <circle cx="17" cy="13" r="1.5" fill="#FFF" opacity="0.9" />
        </svg>
        PRO
      </span>
    </span>
  `,
  styles: [
    `
      .crown-icon-wrapper {
        align-items: center;
        opacity: 1 !important;
        vertical-align: middle;
      }

      .crown-icon {
        display: block;
      }

      .section-title-with-badge {
        display: inline-flex;
        align-items: center;
      }

      .inline-pro-badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 2px 8px;
        border-radius: 4px;
        background: linear-gradient(135deg, #9747ff 0%, #7928ca 100%);
        color: white;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.5px;
        box-shadow: 0 2px 4px rgba(151, 71, 255, 0.2);
      }
      .popup-icon {
      }
    `,
  ],
})
export class CrownIconComponent {
  @Input() tooltip: string = 'This feature is not available in your current plan';
  @Input() size: number = 18;
  @Input() color: string = '#9747FF';
  @Input() customClass: string = '';
  @Input() showBadge: boolean = false;
  @Input() tooltipPlacement: string = 'right';

  // Generate unique ID for gradient to avoid conflicts
  gradientId = `gradient-${Math.random().toString(36).substr(2, 9)}`;
}
